import * as pdfjs from 'pdfjs-dist'
import { Base64ImageUrl, Course, CoursePage, NewCreatedCourse } from './types'

// needs to match the version in package.json EXACTLY!
pdfjs.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.4.120/build/pdf.worker.min.js"

export const convertPdfPagesToBase64ImageUrls = async (file: File): Promise<Array<Base64ImageUrl>> => {
  const arrayBuffer = await file.arrayBuffer()
  const pdf = await pdfjs.getDocument(arrayBuffer).promise
  const pages = []
  
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i)

    const viewport = page.getViewport({ scale: 1.0 })
    const canvas = document.createElement('canvas')
    const canvasContext = canvas.getContext('2d')
    if (!canvasContext) {
      throw new Error('Failed to get canvas context')
    }

    canvas.width = viewport.width
    canvas.height = viewport.height
  
    const renderContext = {
      canvasContext,
      viewport,
    }
    await page.render(renderContext).promise
    const image = canvas.toDataURL('image/jpeg')
    // const content = await page.getTextContent()
    // const text = content.items.map(item => item.str).join(' ')
    pages.push(image)
  }
  
  return pages as Array<Base64ImageUrl>
}

export const processPreviewPictures = (course: Course | NewCreatedCourse) => {
  const updatedPages = course.pages.map((page: CoursePage) => ({
    ...page,
    previewPicture: page.previewPicture.split(',')[1],
  }))

  return {
    ...course,
    pages: updatedPages,
  }
}
